import React from 'react';
import { ReachStage } from '../../../services/reachService';

const STAGE_META: Record<ReachStage, { label: string; bg: string; text: string }> = {
  R: { label: 'Recognise', bg: 'bg-blue-50', text: 'text-blue-700' },
  E: { label: 'Engage', bg: 'bg-purple-50', text: 'text-purple-700' },
  A: { label: 'Acquire', bg: 'bg-amber-50', text: 'text-amber-700' },
  C: { label: 'Capability', bg: 'bg-green-50', text: 'text-green-700' },
  H: { label: 'Habits', bg: 'bg-teal-50', text: 'text-teal-700' },
};

interface Props {
  stage: ReachStage;
  showLabel?: boolean;
  size?: 'sm' | 'md';
}

export const REACHStageBadge: React.FC<Props> = ({ stage, showLabel = true, size = 'md' }) => {
  const meta = STAGE_META[stage];
  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-semibold ${meta.bg} ${meta.text} ${
      size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-xs'
    }`}>
      <span className="font-bold">{stage}</span>
      {showLabel && <span>{meta.label}</span>}
    </span>
  );
};
